import { FormInstance } from "antd/es/form";
import React from "react";
import { IValidationData } from "../../models/dto/validation-data";
import { KContext } from "../../shared/hoc/with-context";
import { KNavigator } from "../../shared/hoc/with-history";
import { KuikaAppManager } from "../../shared/utilty/kuika-app-manager";
import { KMainFunctions } from "../../shared/utilty/main-functions";
import { ReactSystemFunctions } from "../../shared/utilty/react-system-functions";
import { Header2_ScreenContext } from "../header2/header2-context";

declare let window: any;

export interface IBasketReports_ScreenProps {
  navigator: KNavigator;
  form: FormInstance<any>;
  googleLogin: any;
  screenInputs: any;
  context: KContext;
  initialValues: any;
  children: any;
}

interface IBasketReports_ScreenState {
  isSpinnerVisible: boolean;
  isPageVisible: boolean;
  isLeftMenuVisible: boolean;
  spinnerCount: number;
  selectedLanguage: string;
  isPageInitLoaded: false;
  isPageRecurringLoaded: false;
  ActiveBasket: any[];
  ActiveBasket_dummy: any[];
  CompletedBasket: any[];
  CompletedBasket_dummy: any[];
  SetValueOf: any;
  SetValueOf_dummy: any;
  NAVIGATE: any;
  NAVIGATE_dummy: any;
  isComp852280Visible: "visible" | "hidden";
  isComp659108Visible: "visible" | "hidden";
  isComp939256Visible: "visible" | "hidden";
  isComp605612Visible: "visible" | "hidden";
  isComp460956Visible: "visible" | "hidden";
  isCompbasketreports_875174AuthorizationVisible: "visible" | "hidden";
  isCompbasketreports_852280AuthorizationVisible: "visible" | "hidden";
}

export class BasketReports_ScreenBase extends React.PureComponent<
  IBasketReports_ScreenProps,
  any
> {
  static contextType = Header2_ScreenContext;
  declare context: React.ContextType<typeof Header2_ScreenContext>;
  basketreports_287569_value_kuikaTableRef: React.RefObject<any>;
  basketreports_377233_value_kuikaPaginationRef: React.RefObject<any>;
  basketreports_599097_value_kuikaTableRef: React.RefObject<any>;
  basketreports_994572_value_kuikaPaginationRef: React.RefObject<any>;
  ml = [
    {
      Id: "70da2015-72e4-4a73-bc3e-b700175ae3a3",
      Name: "en_US",
      ShortName: "English",
      IsDefault: true,
      LanguagePhrases: [],
    },
    {
      Id: "af9ef643-629d-4e97-b3f2-b3c87aa79a3e",
      Name: "FixedValues",
      ShortName: "FixedValues",
      LanguagePhrases: [
        { Id: 602534, PropertyName: "tab", Value: "Aktif Sepetler" },
        { Id: 307658, PropertyName: "value", Value: "Müşteri Adı" },
        { Id: 365482, PropertyName: "placeholder", Value: "Müşteri Adı" },
        { Id: 402397, PropertyName: "value", Value: "Satış Personeli" },
        { Id: 127883, PropertyName: "placeholder", Value: "Satış Personeli" },
        { Id: 961258, PropertyName: "label", Value: "Temizle" },
        { Id: 444724, PropertyName: "label", Value: "Filtrele" },
        { Id: 546124, PropertyName: "title", Value: "Title" },
        { Id: 99155, PropertyName: "value", Value: "Aktif" },
        { Id: 545305, PropertyName: "value", Value: "[datafield:createdat]" },
        { Id: 894316, PropertyName: "value", Value: "Müşteri Bilgileri" },
        { Id: 25786, PropertyName: "value", Value: "[datafield:curacccode]" },
        {
          Id: 903685,
          PropertyName: "value",
          Value: "[datafield:customername]",
        },
        { Id: 51611, PropertyName: "value", Value: "Satış Personeli" },
        {
          Id: 48222,
          PropertyName: "value",
          Value: "[datafield:salespersoncode]",
        },
        {
          Id: 49054,
          PropertyName: "value",
          Value: "[datafield:salespersonname]",
        },
        { Id: 859377, PropertyName: "value", Value: "Sepetteki Ürün Adedi" },
        {
          Id: 864914,
          PropertyName: "value",
          Value: "[datafield:totalquantity]",
        },
        { Id: 687282, PropertyName: "tab", Value: "Geçmiş Sepetler" },
        { Id: 453444, PropertyName: "value", Value: "Müşteri Adı" },
        { Id: 41021, PropertyName: "placeholder", Value: "Müşteri Adı" },
        { Id: 130906, PropertyName: "value", Value: "Satış Personeli" },
        { Id: 928556, PropertyName: "placeholder", Value: "Satış Personeli" },
        { Id: 18289, PropertyName: "value", Value: "Sepet Numarası" },
        { Id: 873968, PropertyName: "placeholder", Value: "Sepet Numarası" },
        { Id: 24577, PropertyName: "label", Value: "Temizle" },
        { Id: 24124, PropertyName: "label", Value: "Filtrele" },
        { Id: 931769, PropertyName: "title", Value: "Title" },
        { Id: 605612, PropertyName: "value", Value: "İptal Edildi" },
        { Id: 460956, PropertyName: "value", Value: "Tamamlandı" },
        { Id: 489874, PropertyName: "value", Value: "[datafield:createdat]" },
        { Id: 963940, PropertyName: "value", Value: "[datafield:cartno]" },
        { Id: 46902, PropertyName: "value", Value: "Müşteri Bilgileri" },
        { Id: 848986, PropertyName: "value", Value: "[datafield:curacccode]" },
        {
          Id: 612360,
          PropertyName: "value",
          Value: "[datafield:customername]",
        },
        { Id: 881593, PropertyName: "value", Value: "Satış Personeli" },
        {
          Id: 631503,
          PropertyName: "value",
          Value: "[datafield:salespersoncode]",
        },
        {
          Id: 26290,
          PropertyName: "value",
          Value: "[datafield:salespersonname]",
        },
        { Id: 804990, PropertyName: "value", Value: "Sepetteki Ürün Adedi" },
        {
          Id: 23452,
          PropertyName: "value",
          Value: "[datafield:totalquantity]",
        },
      ],
    },
  ];
  defaultML = "en_US";

  screenHash = "";

  private _prevMasterPageInitLoaded: boolean = false;
  private _prevMasterPageRecurringLoaded: boolean = false;
  private _prevShouldTriggerPageInit: boolean = false;
  constructor(props) {
    super(props);
    this.basketreports_365482_value_kuikaTextInputRef = React.createRef();
    this.basketreports_127883_value_kuikaTextInputRef = React.createRef();
    this.basketreports_287569_value_kuikaTableRef = React.createRef();
    this.basketreports_377233_value_kuikaPaginationRef = React.createRef();
    this.basketreports_41021_value_kuikaTextInputRef = React.createRef();
    this.basketreports_928556_value_kuikaTextInputRef = React.createRef();
    this.basketreports_873968_value_kuikaTextInputRef = React.createRef();
    this.basketreports_599097_value_kuikaTableRef = React.createRef();
    this.basketreports_994572_value_kuikaPaginationRef = React.createRef();

    this.state = {
      isSpinnerVisible: false,
      isPageVisible: false,
      isLeftMenuVisible: false,
      spinnerCount: 0,
      selectedLanguage: "",
      isPageInitLoaded: false,
      isPageRecurringLoaded: false,
      ActiveBasket: [],
      CompletedBasket: [],
      SetValueOf: "",
      NAVIGATE: "",
      isComp852280Visible: "hidden",
      isComp659108Visible: "hidden",
      isComp939256Visible: "hidden",
      isComp605612Visible: "hidden",
      isComp460956Visible: "hidden",
      isCompbasketreports_875174AuthorizationVisible: "visible",
      isCompbasketreports_852280AuthorizationVisible: "visible",
    };

    this.state.isPageVisible = true;
  }

  async componentDidMount() {
    if (KuikaAppManager.isPageInitPrevented()) {
      KuikaAppManager.calculateAndSetBodyHeight(
        "basketreports",
        "header2_screen"
      );
      return;
    }
    this.context.registerCallbackFunction(this.callCallbackFunction.bind(this));

    ReactSystemFunctions.validateToken();
    this.fillFormInitValues();
    if (false) {
      await this.BasketReportsPageInit();
    } else if (this.context?.isMasterPageInitLoaded) {
      this._prevMasterPageInitLoaded = true;
      await this.BasketReportsPageInit();
    }
    ReactSystemFunctions.hideIsNotAuthorized(
      this,
      "isCompbasketreports_875174AuthorizationVisible",
      [
        "a597d8b4-25e9-06e0-3e90-d3e664167a2d",
        "89e5ac2f-7495-c991-de70-4d38fd6f1367",
        "_SystemAdmin",
        "BozkurtlarAdmin",
      ]
    );
    ReactSystemFunctions.hideIsNotAuthorized(
      this,
      "isCompbasketreports_852280AuthorizationVisible",
      [
        "a597d8b4-25e9-06e0-3e90-d3e664167a2d",
        "89e5ac2f-7495-c991-de70-4d38fd6f1367",
        "_SystemAdmin",
        "BozkurtlarAdmin",
      ]
    );

    KuikaAppManager.calculateAndSetBodyHeight(
      "basketreports",
      "header2_screen"
    );

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = this;
    }
  }

  componentWillUnmount() {
    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = null;
    }
  }

  componentDidUpdate = async (prevProps, prevState) => {
    KuikaAppManager.calculateAndSetBodyHeight(
      "basketreports",
      "header2_screen"
    );
    if (prevProps?.location?.search !== (this.props as any)?.location?.search) {
      await this.BasketReportsPageInit();
    }

    if (
      this._prevMasterPageInitLoaded !== this.context.isMasterPageInitLoaded &&
      this.context.isMasterPageInitLoaded === true
    ) {
      this._prevMasterPageInitLoaded = this.context.isMasterPageInitLoaded;
      await this.BasketReportsPageInit();
    }

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      for (const key in prevState) {
        if (
          key.startsWith("NavVisible") &&
          prevState[key] === true &&
          this.state[key] === false
        ) {
          window.parentScreen = this;
          break;
        }
      }
    }
  };

  fillFormInitValues() {
    this.props.form?.setFieldsValue({});
  }

  setPageInitLoaded = (value: boolean) => {
    this.setState({ isPageInitLoaded: value });
  };

  setPageRecurringLoaded = (value: boolean) => {
    this.setState({ isPageRecurringLoaded: value });
  };

  clearFieldValidation = (changedValues: any) => {
    const fieldName = Object.keys(changedValues)[0];
    if (fieldName) {
      this.props.form?.setFields([
        {
          name: fieldName,
          errors: [],
        },
      ]);
    }
  };

  checkTabErrors = () => {
    document.querySelectorAll(".rc-tabs-tab").forEach((tab) => {
      (tab as HTMLElement).style.color = "";
    });

    const tabPanes = document.querySelectorAll(".rc-tabs-tabpane");
    const tabs = document.querySelectorAll(".rc-tabs-tab");

    tabPanes.forEach((tabPane, index) => {
      const uniquePaneId = `rc-tabs-tabpane-${index}`;
      if (!tabPane.hasAttribute("id")) {
        tabPane.setAttribute("id", uniquePaneId);
      }

      const uniqueTabId = `rc-tabs-tab-${index}`;
      if (tabs[index]) {
        if (!tabs[index].hasAttribute("id")) {
          tabs[index].setAttribute("id", uniqueTabId);
        }
        tabs[index].setAttribute("aria-controls", uniquePaneId);
      }
    });

    const errorElements = document.querySelectorAll(
      ".rc-tabs .ant-form-item-explain-error"
    );

    const tabsWithErrors = new Set<string>();

    errorElements.forEach((errorElement) => {
      const tabPane = errorElement.closest(".rc-tabs-tabpane");
      if (tabPane && tabPane.id) {
        tabsWithErrors.add(tabPane.id);
      }
    });

    tabsWithErrors.forEach((tabPaneId) => {
      const tab = document.querySelector(
        `.rc-tabs-tab[aria-controls="${tabPaneId}"]`
      );
      if (tab) {
        (tab as HTMLElement).style.color = "red";
      }
    });
  };

  BasketReportsPageInit = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    let localVar = {
      CustomerName_0: ReactSystemFunctions.convertToTypeByName("", "string"),
      SalesPersonName_0: ReactSystemFunctions.convertToTypeByName("", "string"),
      PageNumber_0: ReactSystemFunctions.convertToTypeByName(1, "number"),
      CustomerName_1: ReactSystemFunctions.convertToTypeByName("", "string"),
      SalesPersonName_1: ReactSystemFunctions.convertToTypeByName("", "string"),
      CartNo_1: ReactSystemFunctions.convertToTypeByName("", "string"),
      PageNumber_1: ReactSystemFunctions.convertToTypeByName(1, "number"),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "BasketReports/BasketReportsPageInit",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.ActiveBasket = result?.data.activeBasket;

    stateVars.CompletedBasket = result?.data.completedBasket;

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.BasketReportsPageInit1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  BasketReportsPageInit1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.dataSource_287569 =
      stateVars.ActiveBasket ?? this.state.ActiveBasket;
    formVars.basketreports_377233_total = ReactSystemFunctions.value(
      this,
      stateVars.ActiveBasket !== undefined
        ? stateVars.ActiveBasket?.length > 0
          ? stateVars.ActiveBasket[0].totalRowCount
          : null
        : this.state.ActiveBasket?.length > 0
        ? this.state.ActiveBasket[0].totalRowCount
        : null
    );

    stateVars.dataSource_599097 =
      stateVars.CompletedBasket ?? this.state.CompletedBasket;
    stateVars.isComp852280Visible =
      ReactSystemFunctions.isNotEqualTo(
        ReactSystemFunctions.value(
          this,
          "basketreports_599097_value",
          "statusCode"
        ),
        ReactSystemFunctions.convertToTypeByName("COMPLETED", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp659108Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          "basketreports_599097_value",
          "isCompleted"
        ),
        ReactSystemFunctions.convertToTypeByName("0", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp939256Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          "basketreports_599097_value",
          "isCompleted"
        ),
        ReactSystemFunctions.convertToTypeByName("1", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp605612Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          "basketreports_599097_value",
          "isCompleted"
        ),
        ReactSystemFunctions.convertToTypeByName("0", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp460956Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          "basketreports_599097_value",
          "isCompleted"
        ),
        ReactSystemFunctions.convertToTypeByName("1", "string")
      ) === true
        ? "visible"
        : "hidden";
    formVars.basketreports_994572_total = ReactSystemFunctions.value(
      this,
      stateVars.CompletedBasket !== undefined
        ? stateVars.CompletedBasket?.length > 0
          ? stateVars.CompletedBasket[0].totalRowCount
          : null
        : this.state.CompletedBasket?.length > 0
        ? this.state.CompletedBasket[0].totalRowCount
        : null
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    this.setPageInitLoaded(true);
    return isErrorOccurred;
  };

  BasketReportsComponent_961258_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      CustomerName_0: ReactSystemFunctions.convertToTypeByName("", "string"),
      SalesPersonName_0: ReactSystemFunctions.convertToTypeByName("", "string"),
      PageNumber_0: ReactSystemFunctions.convertToTypeByName(1, "number"),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "BasketReports/BasketReportsComponent_961258_onClick",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.ActiveBasket = result?.data.activeBasket;

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.BasketReportsComponent_961258_onClick1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  BasketReportsComponent_961258_onClick1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
      this,
      ReactSystemFunctions.convertToTypeByName(
        "basketreports_377233_value",
        "string"
      ),
      1,
      ReactSystemFunctions.convertToTypeByName("current", "string"),
      false
    );
    stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
      this,
      ReactSystemFunctions.convertToTypeByName(
        "basketreports_365482_value",
        "string"
      ),
      "",
      null,
      false
    );
    stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
      this,
      ReactSystemFunctions.convertToTypeByName(
        "basketreports_127883_value",
        "string"
      ),
      "",
      null,
      false
    );

    stateVars.dataSource_287569 =
      stateVars.ActiveBasket ?? this.state.ActiveBasket;

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  BasketReportsComponent_444724_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      CustomerName_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "basketreports_365482_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      SalesPersonName_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "basketreports_127883_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      PageNumber_0: ReactSystemFunctions.convertToTypeByName(1, "number"),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "BasketReports/BasketReportsComponent_444724_onClick",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.ActiveBasket = result?.data.activeBasket;

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.BasketReportsComponent_444724_onClick1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  BasketReportsComponent_444724_onClick1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
      this,
      ReactSystemFunctions.convertToTypeByName(
        "basketreports_377233_value",
        "string"
      ),
      1,
      ReactSystemFunctions.convertToTypeByName("current", "string"),
      false
    );

    stateVars.dataSource_287569 =
      stateVars.ActiveBasket ?? this.state.ActiveBasket;

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  BasketReportsComponent_794632_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    const __currentPath = (
      window.location.hash
        ? window.location.hash.replace(/^#/, "").split("?")[0]
        : window.location.pathname.split("?")[0]
    ).toLowerCase();
    if (__currentPath !== "/basketreportsdetail") {
      this.context.setMasterPageInitLoaded(false);
      this.context.setMasterPageRecurringLoaded(false);
      this.context.setShouldTriggerPageInit(true);
    }
    KuikaAppManager.prepareForNavigation();
    KuikaAppManager.addToPageInputVariables(
      "BasketReportsDetail",
      "CartHeaderId",
      ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(this, "basketreports_287569_value", "id"),
        "Guid"
      )
    );

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "BasketReports",
      "BasketReportsDetail",
      "",
      "currentPage",
      null,
      null,
      null,
      null,
      null,
      null,
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  BasketReportsComponent_377233_onChange = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      CustomerName_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "basketreports_365482_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      SalesPersonName_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "basketreports_127883_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      PageNumber_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "basketreports_377233_value",
            "current",
            "",
            "",
            ""
          )
        ),
        "number"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "BasketReports/BasketReportsComponent_377233_onChange",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.ActiveBasket = result?.data.activeBasket;

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.BasketReportsComponent_377233_onChange1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  BasketReportsComponent_377233_onChange1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.dataSource_287569 =
      stateVars.ActiveBasket ?? this.state.ActiveBasket;
    formVars.basketreports_377233_total = ReactSystemFunctions.value(
      this,
      stateVars.ActiveBasket !== undefined
        ? stateVars.ActiveBasket?.length > 0
          ? stateVars.ActiveBasket[0].totalRowCount
          : null
        : this.state.ActiveBasket?.length > 0
        ? this.state.ActiveBasket[0].totalRowCount
        : null
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  BasketReportsComponent_24577_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      CustomerName_0: ReactSystemFunctions.convertToTypeByName("", "string"),
      SalesPersonName_0: ReactSystemFunctions.convertToTypeByName("", "string"),
      CartNo_0: ReactSystemFunctions.convertToTypeByName("", "string"),
      PageNumber_0: ReactSystemFunctions.convertToTypeByName(1, "number"),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "BasketReports/BasketReportsComponent_24577_onClick",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.CompletedBasket = result?.data.completedBasket;

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.BasketReportsComponent_24577_onClick1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  BasketReportsComponent_24577_onClick1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
      this,
      ReactSystemFunctions.convertToTypeByName(
        "basketreports_41021_value",
        "string"
      ),
      "",
      null,
      false
    );
    stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
      this,
      ReactSystemFunctions.convertToTypeByName(
        "basketreports_928556_value",
        "string"
      ),
      "",
      null,
      false
    );
    stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
      this,
      ReactSystemFunctions.convertToTypeByName(
        "basketreports_873968_value",
        "string"
      ),
      "",
      null,
      false
    );
    stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
      this,
      ReactSystemFunctions.convertToTypeByName(
        "basketreports_994572_value",
        "string"
      ),
      1,
      ReactSystemFunctions.convertToTypeByName("current", "string"),
      false
    );

    stateVars.dataSource_599097 =
      stateVars.CompletedBasket ?? this.state.CompletedBasket;

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  BasketReportsComponent_24124_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      CustomerName_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "basketreports_41021_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      SalesPersonName_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "basketreports_928556_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      CartNo_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "basketreports_873968_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      PageNumber_0: ReactSystemFunctions.convertToTypeByName(1, "number"),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "BasketReports/BasketReportsComponent_24124_onClick",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.CompletedBasket = result?.data.completedBasket;

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.BasketReportsComponent_24124_onClick1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  BasketReportsComponent_24124_onClick1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
      this,
      ReactSystemFunctions.convertToTypeByName(
        "basketreports_994572_value",
        "string"
      ),
      1,
      ReactSystemFunctions.convertToTypeByName("current", "string"),
      false
    );

    stateVars.dataSource_599097 =
      stateVars.CompletedBasket ?? this.state.CompletedBasket;

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  BasketReportsComponent_28901_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    const __currentPath = (
      window.location.hash
        ? window.location.hash.replace(/^#/, "").split("?")[0]
        : window.location.pathname.split("?")[0]
    ).toLowerCase();
    if (__currentPath !== "/basketreportsdetail") {
      this.context.setMasterPageInitLoaded(false);
      this.context.setMasterPageRecurringLoaded(false);
      this.context.setShouldTriggerPageInit(true);
    }
    KuikaAppManager.prepareForNavigation();
    KuikaAppManager.addToPageInputVariables(
      "BasketReportsDetail",
      "CartHeaderId",
      ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(this, "basketreports_599097_value", "id"),
        "Guid"
      )
    );

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "BasketReports",
      "BasketReportsDetail",
      "",
      "currentPage",
      null,
      null,
      null,
      null,
      null,
      null,
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  BasketReportsComponent_994572_onChange = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      CustomerName_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "basketreports_41021_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      SalesPersonName_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "basketreports_928556_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      CartNo_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "basketreports_873968_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      PageNumber_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "basketreports_994572_value",
            "current",
            "",
            "",
            ""
          )
        ),
        "number"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "BasketReports/BasketReportsComponent_994572_onChange",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.CompletedBasket = result?.data.completedBasket;

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.BasketReportsComponent_994572_onChange1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  BasketReportsComponent_994572_onChange1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.dataSource_599097 =
      stateVars.CompletedBasket ?? this.state.CompletedBasket;
    formVars.basketreports_994572_total = ReactSystemFunctions.value(
      this,
      stateVars.CompletedBasket !== undefined
        ? stateVars.CompletedBasket?.length > 0
          ? stateVars.CompletedBasket[0].totalRowCount
          : null
        : this.state.CompletedBasket?.length > 0
        ? this.state.CompletedBasket[0].totalRowCount
        : null
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  async callCallbackFunction(diId: number, isFromMaster: boolean = false) {
    let isErrorOccurred = false;
    let pageInitCallerNavDiIDs = [,] as number[];
    if (isFromMaster || pageInitCallerNavDiIDs.indexOf(diId) > -1) {
      await this.BasketReportsPageInit();
    }
  }
}
